<template>
	<div>
		<PersonalBanner />
		<div class="content-zsy" v-loading="loading" style="min-height: 400px;">
			<div class="column-center" v-if="info">
				<h3>리뷰</h3>
		<!--	<div class="content-title" >
					DFGDSG
				</div> -->
				
				<div class="head">
					<div class="member-info">
						<label>회원명</label>
						<div class="name">{{info.nickname}}</div>
					</div>
					<div class="date">{{info.createtime}}</div>
				</div>
				
				<div class="order-item">
					<el-row>
						<el-col :xs="24" :sm="12" style="text-align: center;" class="image-container">
							<!-- <img loading="lazy" style="width:200px; height：100px;" src="https://www.postteam.co.kr/data/files/2025/10/20/ba50fa7015585df66d785cedf4431a00.jpg" alt=""> -->
							<el-image
								  style="width: 240px; height: 240px;border-radius:10px;" 
								  :src="info.inventory?.goods_image"
								  fit="cover">
										<div slot="error" class="image-slot">
											<i class="el-icon-picture-outline"></i>
								        </div>
								  </el-image>
								<!-- 完整图片（与缩略图 src 相同，自动加载完整尺寸） -->
								<img class="full-image" :src="info.inventory?.goods_image" alt=""> 
						</el-col>
						<el-col :xs="24" :sm="12" style="padding-top: 30px;">
							<div class="content-row">
								<div class="title">품목</div>
								<div class="title-value">{{info.cate_name}}</div>
							</div>
							<div class="content-row">
								<div class="title">가격</div>
								<div class="title-value">¥{{info.commodity?.price}}</div>
							</div>
							<div class="content-row">
								<div class="title" >바로가기</div>
								<div class="title-value">
									<a :href="info.inventory?.url" target="_blank">
										{{info.inventory?.url}}
									</a>
									
								</div>
							</div>
						</el-col>
					</el-row>
					
					<div class="divided-line mt50 mb50"></div>
					
					<div>
						<div class="img-list" v-if="info.images?.length>0">
							<div class="image-container" v-for="(item, index) in info.images" :key="index" >
								<el-image
									style="height: 165px;margin: 5px;" 
									:src="item.image_url"
								>
								</el-image>
								<img class="full-image" :src="item.image_url" alt=""> 
							</div>
							
						</div>
						
						<div class="content">
							{{info.comment_content}}
						</div>
						
					</div>
					
				</div>
				
				

			</div>
			
		</div>

	</div>
</template>

<script>
	import PersonalBanner from '../../components/PersonalBanner.vue'
	import request from '@/utils/request'
	export default {
		components: {
			PersonalBanner
		},
		props: ['id'],
		data() {
			return {
				loading: true,
				info: null,
		
			}
		},
		created() {
			this.getCommentInfo()
		},
		methods: {
			getCommentInfo(){
				this.loading = true
				console.log(this.id,123)
				request.post('/Comment/getCommentInfo',{
					id:this.id
				}
				).then(res => {
					this.loading = false
					console.log(res,"信息")
					if(res.code ==1){
						this.info= res.data
					}		
				}).catch(() => {
					this.loading = false
				})	
			}
		}
	
	}
</script>

<style scoped>
	.column-center h3 {
	    text-align: center;
	    font-size: 45px;
	    font-weight: bold;
	    color: var(--frontground-color);
	    padding: 60px 0 0 0;
	    margin: 0 0 60px;
	}
	.content-title{
		font-size: 24px;
		border-top: 2px solid #000;
		text-align: left;
		padding: 13px 15px;
		font-weight: 500;
		background-color: #f5f8fd;
	}
	.head {
	    display: flex;
	    align-items: center;
	    justify-content: space-between;
	    padding-bottom: 10px;
	    border-bottom: 2px solid var(--border-color);
	    margin-bottom: 40px;
	    line-height: normal;
	}
	.head .member-info {
	    display: flex;
	    align-items: center;
	}
	.head .member-info label {
	    width: 52px;
	    margin: 0;
	    font-weight: bold;
	    font-size: 15px;
	}
	.head .member-info .name {
	    background: url("../../assets/icon/ico_review_user.png") no-repeat left center;
	    padding-left: 42px;
	    line-height: 32px;
	    font-size: 12px;
	    color: var(--frontground-color);
	}
	.head .date {
	    font-size: 15px;
	    color: var(--frontground-color);
	}
	.content-row{
		display: flex;align-items: center;margin: 20px 0;
	}
	.content-row .title{
		background-color: #F66D2F;width:110px; text-align: center;padding:3px 0;border-radius: 5px;color:#FFF;font-weight: bold;font-size: 14px;
	}
	.content-row .title-value{
		padding: 0 0 0 20px;
		font-size: 14px;
		color:var(--main-color);
		/* 关键修改 1：让 title-value 占据剩余所有空间 */
		flex: 1; 
		/* 关键修改 2：允许长文本（如URL）在任意字符处换行 */
		word-break: break-all; 
	}
	.content-row .title-value a{
		color:var(--main-color);
		text-decoration: none;

	}
	.divided-line {
	    border-top: 2px solid var(--border-color);
	}
	.mb50 {
	    margin-bottom: 50px !important;
	}
	.mt50 {
	    margin-top: 50px !important;
	}
	/* 完整图片样式（默认隐藏） */
	.full-image {
	  position: absolute;
	  top: 0;
	  left: 50%;
	  transform: translate(-50%, -100%); /* 居中显示 */
	  width: auto; /* 完整图片宽度（可自定义，如 500px） */
	  height: auto; /* 完整图片高度 */
	  /*max-width: 800px;  限制最大宽度，避免超出屏幕 */
	  /* max-height: 600px; */
	  opacity: 0; /* 初始透明 */
	  visibility: hidden; /* 隐藏元素（避免占用空间） */
	  transition: opacity 0.3s ease; /* 淡入淡出动画 */
	  z-index: 100; /* 确保在最上层 */
	  box-shadow: 0 0 20px rgba(0,0,0,0.3); /* 阴影效果，更美观 */
	}
	/* 鼠标悬停时显示完整图片 */
	.image-container:hover .full-image {
	  opacity: 1;
	  visibility: visible;
	}
	.order-item .img-list{
		margin-bottom: 20px;
		display: flex;
		position: relative;
	}
	.order-item .content {
	    font-size: 15px;
	    line-height: 24px;
	    color: var(--frontground-color);
	}
	
	@media (min-width: 992px) {
		.content-zsy{
			width: 992px;
			margin: 2.5rem auto;
		}
	}
	@media (max-width: 768px) {
		.order-item{
			margin:0 10px;
		}
		.head {
			margin-right: 10px; 
			margin-left: 10px;
		}
		.order-item .content{
			margin-bottom: 30px;
		}
		
	}
</style>